import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useFirebase } from "react-redux-firebase";
import CONSTANTS from "../../../misc/constants";
import styled from "styled-components";
import FirebasePaginator from "../../utils/FirebasePaginator";
import EntriesList from "./layouts/EntriesList";
import Text from "../../utils/Text";
import useQuery from "../../hooks/useQuery";

const Blog = () => {
  const [search, setSearch] = useState("");
  const firebase = useFirebase();
  const tagQuery = useQuery().get("tag");
  const categoryQuery = useQuery().get("category");

  const lang = useSelector((store) => store.options.lang);

  const [firebaseQuery, setFirebasQuery] = useState(
    firebase.ref("blog_entries").orderByChild("meta/creationDate")
  );
  const firstRender = useRef(true);

  
  useEffect(() => {
    if (firstRender.current) {
      document.title = `${CONSTANTS.APP_NAME} | Blog`;
      firstRender.current = false;
    }
    if (search && search.trim() !== "") {
      const searchValue = search.replace(" ", "_").toLowerCase();
      setFirebasQuery(
        firebase
          .ref("blog_entries")
          .orderByChild(`search_${lang.code}`)
          .startAt(`${searchValue}`)
          .endAt(`${searchValue}\uf8ff`)
      );
    } else {
      if (tagQuery && tagQuery.trim() !== "") {
        setSearch("");
        setFirebasQuery(
          firebase
            .ref("blog_entries")
            .orderByChild(`meta/tags/${tagQuery}`)
            .equalTo(true)
        );
      } else if (categoryQuery && categoryQuery.trim() !== "") {
        setSearch("");
        setFirebasQuery(
          firebase
            .ref("blog_entries")
            .orderByChild(`entryType`)
            .equalTo(categoryQuery.replace("_", " "))
        );
      } else {
        setFirebasQuery(
          firebase.ref("blog_entries").orderByChild("meta/updateDate")
        );
      }
    }
  }, [search, setFirebasQuery, firebase, tagQuery, categoryQuery, lang]);

  const paginatorUrlParams = () => {
    if (categoryQuery && categoryQuery.trim() !== "") {
      return `?category=${categoryQuery}`;
    } else if (tagQuery && tagQuery.trim() !== "") {
      return `?tag=${tagQuery}`;
    } else {
      return "";
    }
  };

  return (
    <BlogContainer>
      <h1>Blog</h1>
      <div className="blog-content">
        <div className="entries-container">
          {!tagQuery && !categoryQuery && (
            <Text
              type="search"
              value={search}
              onChange={setSearch}
              placeholder={lang.data.blog.search}
              className="search-bar"
            ></Text>
          )}
          <FirebasePaginator
            ChildComponent={EntriesList}
            firebaseQuery={firebaseQuery}
            urlPath="/blog"
            pageSize={6}
            urlParams={`${paginatorUrlParams()}`}
            reverse={true}
            nextText={lang.data.next}
            prevText={lang.data.prev}
          />
        </div>
      </div>
    </BlogContainer>
  );
};

const BlogContainer = styled.div`
  margin: 2rem;
  .search-bar {
    width: 100%;
  }
  .blog-content {
    display: flex;
    flex-direction: column-reverse;
    .entries-container {
      display: flex;
      flex-wrap: wrap;
      .entry {
        width: 100%;
        margin: 2rem 1rem;
        padding: 1rem;
        max-height: 100rem;
        display: flex;
        flex-direction: column;
        border-bottom: 0.1rem solid var(--mainColor);
        border-left: 0.1rem solid var(--mainColor);
        a {
          text-decoration: none;
        }
        .featured-img {
          width: 100%;
          height: auto;
        }
        .entry-content {
          padding: 0 1rem;
          .title {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-top: 1rem;
            h2 {
              margin: 0;
              padding: 0;
            }
            .logo-type {
              height: 4rem;
              width: auto;
            }
          }
        }

        ul.tags {
          justify-self: flex-end;
          padding-left: 35%;
          display: flex;
          flex-wrap: wrap;
          justify-content: flex-end;
          margin-bottom: 0%;
          margin-top: auto;
        }

        @media (min-width: 992px) {
          width: 40%;
        }

        @media (min-width: 1200px) {
          width: 28%;
        }
      }
      ul {
        display: flex;
        flex-wrap: wrap;
        padding: 0;
        li {
          list-style: none;
        }
      }
      @media (min-width: 992px) {
        width: 80%;
        margin: 0 10%;
      }
    }
    .elements-container {
      width: 100%;
    }

    @media (min-width: 992px) {
      flex-direction: row;
    }
    .pag-controls {
      width: 100%;
      padding: 0 0.6rem;
      .next {
        float: right;
      }
      .prev {
        float: left;
      }
    }
  }
`;
export default Blog;
